import { gql } from '@apollo/client';
import { NamedBucketDefFragment } from '../../../utils/apollo/builderFragments';

// field and schemaId fields are only relevant for ENUM buckets
export default gql`
  query NamedBucketDefs(
    $includes: [ID]
    $term: String
    $kinds: [BucketKind]
    $schemaId: ID
    $field: String
  ) {
    namedBucketDefs(
      includes: $includes
      term: $term
      kinds: $kinds
      schemaId: $schemaId
      field: $field
    ) {
      entities {
        ...NamedBucketDefFields
      }
    }
  }
  ${NamedBucketDefFragment}
`;
